import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * RouteTracker component
 * Automatically stores the current route in localStorage
 * to preserve user location on page refresh
 */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Don't store login page as return location
    if (location.pathname !== '/login') {
      localStorage.setItem('lastRoute', location.pathname + location.search);
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default RouteTracker;